import React, { useState} from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function TableArbitre(props) {


    const [donnée_arbitre] = useState(props.userData.user.arbitre);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false); 
    const [response, setResponse] = useState(false);
    const [supprimer,setSupprimer] = useState(false)
    const [arbitre_supp,setArbitre_supp]  = useState(null)
    const apiUrl = process.env.REACT_APP_API_URL;






  const handleSubmit = async (e,action, arbitreID) => {
      e.preventDefault();
      setIsLoading(true)
      try {
          const response = await axios.post(`${apiUrl}/verification/arbitre`,
              {
                verification: action,
                id_arbitre : arbitreID,


              },
              {
                withCredentials: true 
              }
            );
            setResponse(response.data)
            setArbitre_supp([])
            setIsLoading(false)
            setTimeout(() => {
              window.location.reload(); 
            }, 3000);
            }catch(error){
              setArbitre_supp([])
              if (error.response) {
              
                setError(error.response.data.message);
              } else {
            
                setError(true)
              }
              setIsLoading(false)
        
            }



  }


if(isLoading){
  return(
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
  )
}


  return (
  <>
      {error && 
        <div id="alert-message" className="alert4" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
        }
    {response && 
    <>
        <div id="alert-message" className="alert3" >
            <strong>Vérification réalisée avec succés !</strong> {response.message}<span id="alert-text"></span>
        </div>
   </>
        }
          {supprimer && (
      <Modal show={supprimer} onHide={() => {setSupprimer(false); setArbitre_supp([])}}>
        <Modal.Header closeButton>
          <Modal.Title>Êtes-vous sûr de réaliser cette action ?</Modal.Title>
        </Modal.Header>
        <Modal.Body>        
            <>{arbitre_supp[0]} {arbitre_supp[3]} {arbitre_supp[2]} ?</>
            <br/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {setSupprimer(false); setArbitre_supp([])}}>
            Annuler
          </Button>
          <Button style={{backgroundColor:"#00E676", borderColor:'#00E676'}} variant="primary" onClick={(e) => {setSupprimer(false);handleSubmit(e, arbitre_supp[0],arbitre_supp[1])}}>
          {arbitre_supp[0] === "Accepter" ? (<>Accepter</>) : (<>Supprimer</>) }
          </Button>
        </Modal.Footer>
      </Modal>
      )}
<h2 className="admin_">Arbitres</h2>
    <table id='admin'>
        <thead>
            <tr>
            <th scope="col">id</th>
            <th scope="col">Nom</th>
            <th scope="col">Prenom</th>
            <th scope="col">Email</th>
            <th scope="col">Contact</th>
            <th scope="col">Vérification de l'email</th>
            <th scope="col">Fichier</th>
            <th scope="col">Vérification</th>
            </tr>
        </thead>
        <tbody>
            {donnée_arbitre && donnée_arbitre.results && donnée_arbitre.results.map((item, index) => (
                <tr key={index}>
                    <td data-label="id">{item.id_arbitre}</td>
                    <td data-label="nom">{item.nom}</td>
                    <td data-label="prenom">{item.prenom}</td>
                    <td data-label="email">{item.email}</td>
                    <td data-label="contact">{item.contact}</td>
                    <td data-label="verification de l'email">{item.verif_email}</td>
                    <td data-label="Fichier"><a href={`${apiUrl}/telecharger/fichier/arbitre/${item.nom_fichier}`} target="_blank" rel="noreferrer">{item.nom_fichier}</a></td>
                    {item.verif_fichier === "false" ? (
                      <td id="verif_admin" data-label="Vérification"><button onClick={(e) => {setSupprimer(true);setArbitre_supp(["Accepter",item.id_arbitre,item.prenom,item.nom]);}}>  Accepter  </button>   <button onClick={(e) => {setSupprimer(true);setArbitre_supp(["Rejeter",item.id_arbitre,item.prenom,item.nom]);}}>  Rejeter  </button></td>
                    ) : (

                        <td id="verif_admin" data-label="Vérification">Arbitre vérifier</td>
                    )}

                </tr>
            ))}
        </tbody>
    </table>

   </> 

    );
}

export default TableArbitre;